import { Component } from '@angular/core';
import { ArticleSeoComponent } from '../article-seo';
import { ArticleTemplateComponent } from '../article-template/article-template.component';

@Component({
  selector: 'app-article-01',
  imports: [ArticleTemplateComponent],
  templateUrl: './article-01.component.html',
  styleUrls: []
})
export class Article01Component extends ArticleSeoComponent {
  protected readonly seo = {
    pageTitle: 'Como começar a participar de leilões da Caixa: guia para iniciantes | Casato Brasil',
    description: 'Aprenda como começar a participar de leilões da Caixa com mais segurança, entendendo edital, matrícula, custos e planejamento antes do primeiro lance.'
  };
}
